const API = {
  SUPPORT: "https://addfriends.com/support-KSEU/",
  RIVER: "https://addfriends.com/brains/",
  AVATAR_URL: "https://static.addfriends.com/images/sites/",
  XSRF:
    "&f4&Q4!!euCxjx&&VNPH71SBJujUg0J#XDK7Q8Xn9QSTtKenPQTG3j&A^JrtjyY9su3*hLLK1S",
}
export default API
